const scrollTop = (selector, comeUpValue) => {
  let elementTopOffset = $(selector).offset().top;

  if (comeUpValue !== undefined) elementTopOffset -= comeUpValue;

  $(document).scrollTop(elementTopOffset);
};

export default scrollTop;
